module.exports = __webpack_public_path__ + "media/Sol.59c1ca3e.wav";